// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panelTop {
    display: block;
    width: 100%;
    height: 180px;
    border: 1px solid var(--formBorder);
    position: relative;
    overflow: auto;
}

.mychips {
    display: inline-block;
    font-size: 14px;
    height: 32px;
    line-height: 30px;
    border-radius: 20px;
    background-color: var(--chipsBackground);
    cursor: pointer;
    margin: 2px 2px;
}

.mychips mat-icon {
    margin: 5px 5px 5px 5px;
    opacity: 0.5;
    font-size: 20px;
    text-align: center;
}

.mychips span {
    padding-left: 3px;
    padding-right: 3px;
    vertical-align: top;
}
.mychips:hover {
    opacity: 0.9;
}

.mychips-selected {
    background-color: var(--chipSelectedBackground);
    color: var(--chipSelectedColor);
}

.toolbox-toadd {
    position: absolute;
    right: 50px;
    top: -40px;
}

.panelTop .chart-list,
.device-list,
.tag-list {
    height: 480px;
}

.panelBottom {
    display: block;
    width: 100%;
    height: 300px;
    margin-top: 10px;
}

.list {
    width: 100% !important;
    height: 100% !important;
    font-size: 16px !important;
    padding-top: 0px !important;
}

.list > span {
    padding-left: 10px;
}

.list mat-list-option {
    padding-left: 10px;
}

.chart-list {
    overflow-y: auto;
}

.list-item {
    display: block;
    font-size: 14px;
    height: 26px !important;
    cursor: pointer;
    overflow: hidden;
    padding-left: 10px;
}

.list-item mat-icon {
    font-size: 20px;
}

.list-item span {
    text-overflow: ellipsis;
    overflow: hidden;
}

.list-item-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.list-item-hover:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

.list-item-selected {
    background-color: rgba(0, 0, 0, 0.1);
}

.list-item-sel {
    padding-left: 5px !important;
}

.list-header {
    background-color: rgba(0, 0, 0, 0.8);
    color: #ffffff;
    line-height: 26px;
    cursor: unset;
}

.list-item-remove {
    width: 20px;
    max-width: 20px;
}

.list-item-name {
    width: 25%;
    max-width: 25%;
}

.list-item-label {
    width: 30%;
    max-width: 30%;
}

.list-item-device {
    width: 25%;
    max-width: 25%;
}

.list-item-yaxis {
    width: 10%;
    max-width: 10%;
}

.list-item-interpolation {
    width: 10%;
    max-width: 10%;
}

.list-item-color {
    width: 5%;
    max-width: 5%;
}

.list-panel {
    height: calc(100% - 26px); 
    overflow-x: hidden;
}

.device-list {
    margin-right: 2px;
    overflow-y: auto;
}

.tag-list {
    margin-right: 2px;
    overflow-y: auto;
}

.color-line {
    width: 30px;
    border: unset;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    opacity: 1;
    background-color: #f1f3f4;
}
`, "",{"version":3,"sources":["webpack://./src/app/editor/chart-config/chart-config.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mCAAmC;IACnC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,+CAA+C;IAC/C,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,yBAAyB;AAC7B","sourcesContent":[".panelTop {\n    display: block;\n    width: 100%;\n    height: 180px;\n    border: 1px solid var(--formBorder);\n    position: relative;\n    overflow: auto;\n}\n\n.mychips {\n    display: inline-block;\n    font-size: 14px;\n    height: 32px;\n    line-height: 30px;\n    border-radius: 20px;\n    background-color: var(--chipsBackground);\n    cursor: pointer;\n    margin: 2px 2px;\n}\n\n.mychips mat-icon {\n    margin: 5px 5px 5px 5px;\n    opacity: 0.5;\n    font-size: 20px;\n    text-align: center;\n}\n\n.mychips span {\n    padding-left: 3px;\n    padding-right: 3px;\n    vertical-align: top;\n}\n.mychips:hover {\n    opacity: 0.9;\n}\n\n.mychips-selected {\n    background-color: var(--chipSelectedBackground);\n    color: var(--chipSelectedColor);\n}\n\n.toolbox-toadd {\n    position: absolute;\n    right: 50px;\n    top: -40px;\n}\n\n.panelTop .chart-list,\n.device-list,\n.tag-list {\n    height: 480px;\n}\n\n.panelBottom {\n    display: block;\n    width: 100%;\n    height: 300px;\n    margin-top: 10px;\n}\n\n.list {\n    width: 100% !important;\n    height: 100% !important;\n    font-size: 16px !important;\n    padding-top: 0px !important;\n}\n\n.list > span {\n    padding-left: 10px;\n}\n\n.list mat-list-option {\n    padding-left: 10px;\n}\n\n.chart-list {\n    overflow-y: auto;\n}\n\n.list-item {\n    display: block;\n    font-size: 14px;\n    height: 26px !important;\n    cursor: pointer;\n    overflow: hidden;\n    padding-left: 10px;\n}\n\n.list-item mat-icon {\n    font-size: 20px;\n}\n\n.list-item span {\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.list-item-text {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.list-item-hover:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n.list-item-selected {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n.list-item-sel {\n    padding-left: 5px !important;\n}\n\n.list-header {\n    background-color: rgba(0, 0, 0, 0.8);\n    color: #ffffff;\n    line-height: 26px;\n    cursor: unset;\n}\n\n.list-item-remove {\n    width: 20px;\n    max-width: 20px;\n}\n\n.list-item-name {\n    width: 25%;\n    max-width: 25%;\n}\n\n.list-item-label {\n    width: 30%;\n    max-width: 30%;\n}\n\n.list-item-device {\n    width: 25%;\n    max-width: 25%;\n}\n\n.list-item-yaxis {\n    width: 10%;\n    max-width: 10%;\n}\n\n.list-item-interpolation {\n    width: 10%;\n    max-width: 10%;\n}\n\n.list-item-color {\n    width: 5%;\n    max-width: 5%;\n}\n\n.list-panel {\n    height: calc(100% - 26px); \n    overflow-x: hidden;\n}\n\n.device-list {\n    margin-right: 2px;\n    overflow-y: auto;\n}\n\n.tag-list {\n    margin-right: 2px;\n    overflow-y: auto;\n}\n\n.color-line {\n    width: 30px;\n    border: unset;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 2px;\n    opacity: 1;\n    background-color: #f1f3f4;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
